import { Component, Input, OnInit } from '@angular/core';
import IPBoard from 'src/app/model/product/ip-board/ip-board';
import IPBoardPlacement from 'src/app/model/product/ip-board/ip-board-placement';
import { FileHelper } from '../../../../../../../helpers/file-helper';

@Component({
  selector: 'client-ip-board-arrows-summary',
  templateUrl: 'client-ip-board-arrows-summary.component.html',
  styleUrls: ['client-ip-board-arrows-summary.component.scss'],
})
export class ClientIPBoardArrowsSummaryComponent implements OnInit {
  @Input()
  ipBoard: IPBoard;
  @Input()
  multiple: boolean;
  @Input()
  index: number;
  isImage = FileHelper.isImage;
  ipBoardPlacement: IPBoardPlacement;

  ngOnInit(): void {
    this.ipBoardPlacement = <IPBoardPlacement>this.ipBoard.productPlacement;
  }
}
